<div class="appContentsContainer">
  <div
    id="mantenimientoContainer"
    class="backgroundSand container fullWidthContainer listPage smallTables"
  >
    <div class="pageTitle mb-1 mt-1">
      {{ "certificatesQuery.titleList" | translate }}
    </div>

    <div
      class="pageTitle collapsibleTitle"
      [ngStyle]="{ 'margin-bottom': !filterTramite ? '57px' : '' }"
    >
      <div class="collapseButtonContainer">
        <button
          *ngIf="!filterTramite"
          class="submitSearchButton"
          (click)="filterTramite = !filterTramite"
        >
          <em class="fas fa-angle-up"></em>
        </button>
        <button
          *ngIf="filterTramite"
          class="submitSearchButton"
          (click)="filterTramite = !filterTramite"
        >
          <em class="fas fa-angle-down"></em>
        </button>
        <h5>En trámite</h5>
      </div>
    </div>

    <div
      [hidden]="!filterTramite"
      class="collapsibleContainer"
      [ngClass]="{
        smaller: filterHistorico,
        expanded: !filterHistorico
      }"
    >
      <div class="filterTableContainer">
        <app-filters
          class="consultaOutFilters"
          #outTable
          [filterList]="filterListOutTable"
          [options]="optionsFiltersOutTable"
          [type]="'consulta'"
          (showfilterButtons)="toggleFilterButtons($event)"
          (showFilters)="showFilters($event)"
          class="outTableFilter"
        ></app-filters>
        <app-filters
          #insideTable
          [filterList]="filterList"
          [options]="optionsMailBoxFilter"
          [ngClass]="{ filterHidden: !showTableFilter }"
          (showFilters)="showFilters($event)"
          class="inTableFilter"
        ></app-filters>
        <app-table
          #certificates
          [tableList]="tableList"
          [elementList]="certificatesList"
          [routing]="routingMailBox"
          [numPages]="numPages"
          [numElements]="numElements"
          [totalElements]="totalElements"
          [filterParams]="filtersTableJSON"
          [options]="optionsMailBox"
          [showFilterButtons]="showFilterButtons"
          (valueFilterTable)="filterTable($event)"
          (headerButtonsActionEvent)="buttonsHeader($event)"
        ></app-table>
      </div>
    </div>
    <div class="pageTitle collapsibleTitle">
      <div class="collapseButtonContainer">
        <button
          *ngIf="!filterHistorico"
          class="submitSearchButton"
          (click)="filterHistorico = !filterHistorico"
        >
          <em class="fas fa-angle-up"></em>
        </button>
        <button
          *ngIf="filterHistorico"
          class="submitSearchButton"
          (click)="filterHistorico = !filterHistorico"
        >
          <em class="fas fa-angle-down"></em>
        </button>
        <h5>Histórico</h5>
      </div>
    </div>
    <div
      [hidden]="!filterHistorico"
      class="collapsibleContainer"
      [ngClass]="{
        smaller: filterTramite,
        expanded: !filterTramite
      }"
    >
      <div class="noFilterTableContainer">
        <app-table
          class="secondTable tableExtraSpaceForEditButtonInFilter"
          #certificatesHistory
          [tableList]="tableHistoryList"
          [elementList]="certificatesHistoryList"
          [routing]="routingHistory"
          [numPages]="numPagesHistory"
          [numElements]="numElementsHistory"
          [totalElements]="totalElementsHistory"
          [filterParams]="filtersTableHistoryJSON"
          [options]="optionsHistory"
          (valueFilterTable)="filterTableHistory($event)"
          (valuePreviousCerts)="previousHCertsList($event)"
        ></app-table>
      </div>
    </div>
    <div>
      <app-modal-table
        class="secondTable"
        #modal
        [title]="titleModal"
        [tableList]="tablePrevCertsList"
        [elementList]="previousCertsList"
        [filterParams]="filtersPrevCertsJSON"
        [options]="optionsPrevCerts"
        (valueFilterTable)="filterPrevCerts($event)"
        (downloadFile)="downloadCert($event, false)"
      ></app-modal-table>
    </div>
  </div>
  <button class="formButtonBack mt-3 ml-3" *ngIf="!userConcesionario" [ngStyle]="{ 'line-height': '0.8', 'font-size': '17px' }" (click)="exportToExcel()">
    <em class="fas fa-file-excel"></em>
  </button>
</div>
